/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityContractInfo = {
    CNTRCTADDR: string;
    LBL: string;
    COMPVR: string;
    EVR: string;
    TRXCNT: string;
    TRXCNTCH: string;
    BAL: string;
    PRX: HumanityContractInfo.PRX;
    VA: number;
};

export namespace HumanityContractInfo {

    export enum PRX {
        Y = 'Y',
        N = 'N',
    }


}

